<div class="container mt-4">
  <div id="accordion">
    <!-- Request Step -->
    <div class="card" *ngIf="requestStepVisible">
      <div class="card-header" id="headingRequestStep">
        <div class="d-flex justify-content-between">
          <h5 class="mb-0">
            Request {{ activity.model.inspectionType }} Inspection
          </h5>
          <span
            *ngIf="activity.requestStepSubmitted"
            class="text-success ml-2"
            title="Submitted"
          >
            &#10003;
          </span>
          <span
            *ngIf="!activity.requestStepSubmitted"
            class="text-muted ml-2"
            title="Not submitted"
          >
            &#9711;
          </span>
        </div>
      </div>
      <div [ngClass]="{ show: true }">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <wm-form-activity-input-view
                [activity]="activity.model.requestStepActivity"
                [form]="form"
                [applicationId]="applicationId"
                [isReadOnly]="true"
              ></wm-form-activity-input-view>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Schedule Step -->
    <div class="card" *ngIf="scheduleStepVisible">
      <div class="card-header" id="headingScheduleStep">
        <div class="d-flex justify-content-between">
          <h5 class="mb-0">
            Schedule {{ activity.model.inspectionType }} Inspection
          </h5>
          <span
            *ngIf="activity.scheduleStepSubmitted"
            class="text-success ml-2"
            title="Submitted"
          >
            &#10003;
          </span>
          <span
            *ngIf="!activity.scheduleStepSubmitted"
            class="text-muted ml-2"
            title="Not submitted"
          >
            &#9711;
          </span>
        </div>
      </div>
      <div
        [ngClass]="{
          hide: !activity.responsibleForSchedule,
          show: activity.responsibleForSchedule
        }"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <wm-form-activity-input-view
                [activity]="activity.model.scheduleStepActivity"
                [form]="form"
                [applicationId]="applicationId"
                [isReadOnly]="true"
              ></wm-form-activity-input-view>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Complete Step -->
    <div class="card">
      <div class="card-header" id="headingCompleteStep">
        <div class="d-flex justify-content-between">
          <h5 class="mb-0">
            Complete {{ activity.model.inspectionType }} Inspection
          </h5>
          <span
            *ngIf="activity.status === ActivityStatus.Completed"
            class="text-success ml-2"
            title="Submitted"
          >
            &#10003;
          </span>
          <span
            *ngIf="activity.status !== ActivityStatus.Completed"
            class="text-muted ml-2"
            title="Not submitted"
          >
            &#9711;
          </span>
        </div>
      </div>
      <div
        [ngClass]="{
          hide: !activity.responsibleForComplete,
          show: activity.responsibleForComplete
        }"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <wm-form-activity-input-view
                [activity]="activity.model.completeStepActivity"
                [form]="form"
                [applicationId]="applicationId"
                [isReadOnly]="true"
              ></wm-form-activity-input-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
